module.exports = __webpack_public_path__ + "img/fishing-boat.97b2ce04.svg";